import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import axiosRetry from "axios-retry";

const axiosConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  responseType: "json",
};

const axiosInstance: AxiosInstance = axios.create(axiosConfig);
axiosRetry(axiosInstance, {
  retries: 2,
  shouldResetTimeout: true,
  retryCondition: (error) => {
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) ||
      error.code === "ECONNABORTED"
    );
  },
});

export default axiosInstance;
